/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';

export default class CoreSubjectSection extends Component {
  expectations = [];

  @computed('expectations.[]')
  get expectationsBySubject() {
    if (isEmpty(this.expectations)) {
      return {};
    }
    return this.expectations.reduce((mapped, expectation) => {
      let subjectId = expectation.get('goalSubject.id');
      if (isEmpty(mapped[subjectId])) {
        mapped[subjectId] = [];
      }
      mapped[subjectId].push(expectation);
      return mapped;
    }, {});
  }
}
